import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

export default function QCXCheckbox(props) {
  return (
    <Checkbox {...props} />
  );
}
